import { render, staticRenderFns } from "./SupplierSelect.vue?vue&type=template&id=0283750e"
import script from "./SupplierSelect.vue?vue&type=script&lang=js"
export * from "./SupplierSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports